<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.25 18H7.5V17.25C7.5 16.8375 7.1625 16.5 6.75 16.5H5.25C4.8375 16.5 4.5 16.8375 4.5 17.25V18H0.75C0.3375 18 0 18.3375 0 18.75V20.25C0 20.6625 0.3375 21 0.75 21H4.5V21.75C4.5 22.1625 4.8375 22.5 5.25 22.5H6.75C7.1625 22.5 7.5 22.1625 7.5 21.75V21H23.25C23.6625 21 24 20.6625 24 20.25V18.75C24 18.3375 23.6625 18 23.25 18ZM23.25 10.5H19.5V9.75C19.5 9.3375 19.1625 9 18.75 9H17.25C16.8375 9 16.5 9.3375 16.5 9.75V10.5H0.75C0.3375 10.5 0 10.8375 0 11.25V12.75C0 13.1625 0.3375 13.5 0.75 13.5H16.5V14.25C16.5 14.6625 16.8375 15 17.25 15H18.75C19.1625 15 19.5 14.6625 19.5 14.25V13.5H23.25C23.6625 13.5 24 13.1625 24 12.75V11.25C24 10.8375 23.6625 10.5 23.25 10.5ZM23.25 3H13.5V2.25C13.5 1.8375 13.1625 1.5 12.75 1.5H11.25C10.8375 1.5 10.5 1.8375 10.5 2.25V3H0.75C0.3375 3 0 3.3375 0 3.75V5.25C0 5.6625 0.3375 6 0.75 6H10.5V6.75C10.5 7.1625 10.8375 7.5 11.25 7.5H12.75C13.1625 7.5 13.5 7.1625 13.5 6.75V6H23.25C23.6625 6 24 5.6625 24 5.25V3.75C24 3.3375 23.6625 3 23.25 3Z"
      fill="currentColor"
    />
  </svg>
</template>
